import axios from '@/axios'

export default {
  namespaced: true,
  state: {
    pages: {},
    loaded: false,
  },
  mutations: {
    SET_PAGES(state, pages) {
      state.pages = pages
    },
    SET_LOADED(state, value) {
      state.loaded = value
    },
    SET_PAGE(state, { pageKey, config }) {
      state.pages = { ...state.pages, [pageKey]: config }
    },
    RESET_PAGE(state, pageKey) {
      const next = { ...state.pages }
      delete next[pageKey]
      state.pages = next
    },
    CLEAR(state) {
      state.pages = {}
      state.loaded = false
    },
  },
  actions: {
    async fetchAll({ commit }) {
      try {
        const response = await axios.get('api/ui-preferences/pages/')
        const pages = response.data.reduce(
          (acc, row) => ({ ...acc, [row.page_key]: row.config }),
          {}
        )
        commit('SET_PAGES', pages)
      } catch (error) {
        commit('CLEAR')
        console.error(error)
      } finally {
        commit('SET_LOADED', true)
      }
    },
    async save({ commit }, { pageKey, config }) {
      const response = await axios.put(`api/ui-preferences/pages/${pageKey}/`, { config })
      commit('SET_PAGE', { pageKey, config: response.data.config })
      return response.data
    },
    async reset({ commit }, pageKey) {
      await axios.delete(`api/ui-preferences/pages/${pageKey}/`)
      commit('RESET_PAGE', pageKey)
    },
    clear({ commit }) {
      commit('CLEAR')
    },
  },
}
